import withAuthGuard from '@hocs/withAuthGuard';
import withVerificationGuard from '@hocs/withVerificationGuard';
import { flowRight } from 'lodash';

import ReferralLinks from './ReferralLinks';

export default flowRight(withVerificationGuard, withAuthGuard())(ReferralLinks);
